import { ref } from 'vue';

// Peticiones HTTP en curso y estado de carga global.
export const pendingRequests = ref(0);
export const isLoading = ref(false);

let hideTimer = null;

export function startRequest() {
  pendingRequests.value++;
  clearTimeout(hideTimer);
  isLoading.value = true;
}

export function endRequest() {
  pendingRequests.value = Math.max(0, pendingRequests.value - 1);
  if (pendingRequests.value === 0) {
    // Pequeño retardo para evitar parpadeo entre peticiones encadenadas.
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      if (pendingRequests.value === 0) {
        isLoading.value = false;
      }
    }, 200);
  }
}
